import { render, staticRenderFns } from "./addLibrerias.vue?vue&type=template&id=13f67bc1"
import script from "./addLibrerias.vue?vue&type=script&lang=js"
export * from "./addLibrerias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports